import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TravelerSelectorModule } from '@dynamic-components/booker-v2/shared/traveler-selector/traveler-selector.module';
import { JbActionModule } from 'jb-component-library';

import { PipesModule } from '../../../../../shared/ui/pipes/pipes.module';
import { MultiCityRowModule } from '../../../shared/multi-city-row/multi-city-row.module';
import { BookerAirMultiCityComponent } from './booker-air-multi-city.component';

const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  MultiCityRowModule,
  JbActionModule,
  PipesModule,
  TravelerSelectorModule,
];

const DECLARATIONS = [BookerAirMultiCityComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...DECLARATIONS],
})
export class BookerAirMultiCityModule {}
